import { useContext } from "react";
import { PromptInputController } from "./PromptInputController";

// Optional variants (do NOT throw). Useful for dual-mode components.
export const useOptionalPromptInputController = () =>
  useContext(PromptInputController);
